import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
import { trackAddToCart } from '../utils/metaPixel';
const benefits = ['Manual completo en formato digital', 'Acceso inmediato después del pago', 'Estrategias probadas para padres hispanos en USA', 'Inversión menor que una cena familiar', 'Al momento de tu compra podrás recibir bonos adicionales más adelante'];
export function OfferSection() {
  const handlePurchase = () => {
    // Track AddToCart event
    trackAddToCart();
    // Redirect to Shopify cart
    window.location.href = 'https://proyectopatriarca.com//cart/48883117981936:1';
  };
  return <section className="w-full bg-navy-medium py-16 md:py-24 px-4" data-id="element-118">
      <div className="max-w-4xl mx-auto" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-120">
          <h2 className="font-heading text-4xl md:text-5xl text-white mb-6" data-id="element-121">
            Transforma Tu Miedo en{' '}
            <span className="text-gold" data-id="element-122">Estrategia de Hierro</span>
          </h2>
          <p className="font-body text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed" data-id="element-123">
            Por solo $6.36, obtén acceso inmediato al manual que transformará tu
            miedo en una estrategia de hierro.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-navy-dark border-2 border-gold rounded-lg p-8 md:p-12 mb-12" data-id="element-124">
            <div className="mb-8" data-id="element-125">
              <div className="flex justify-center mb-6" data-id="element-126">
                <CountdownTimer data-id="element-127" />
              </div>

              <div className="inline-block bg-red-600 text-white text-sm font-bold px-3 py-1 rounded-full mb-4" data-id="element-128">
                76% DE DESCUENTO
              </div>
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-129">
                <span className="text-3xl md:text-4xl font-heading text-gray-500 line-through" data-id="element-130">
                  $27
                </span>
                <span className="text-6xl md:text-7xl font-heading text-gold" data-id="element-131">
                  $6.36
                </span>
              </div>
              <p className="text-gray-400 text-lg" data-id="element-132">
                Inversión única - Oferta por tiempo limitado
              </p>
            </div>

            <ul className="space-y-4 mb-10 text-left max-w-md mx-auto" role="list" data-id="element-133">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.3 + index * 0.1
            }} className="flex items-start" data-id="element-134">
                  <CheckIcon className="w-6 h-6 text-gold mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-135" />
                  <span className="font-body text-gray-300 text-lg" data-id="element-136">
                    {benefit}
                  </span>
                </motion.li>)}
            </ul>

            <div id="offer" className="flex justify-center" data-id="element-137">
              <CTAButton onClick={handlePurchase} className="w-full md:w-auto" ariaLabel="Comprar el manual por $6.36" data-id="element-138">
                DESCARGAR AHORA
              </CTAButton>
            </div>
          </motion.div>

          <p className="font-body text-gray-400 text-sm" data-id="element-139">
            Acceso inmediato • Formato digital • Garantía de satisfacción
          </p>
        </motion.div>
      </div>
    </section>;
}